export default __webpack_public_path__ + "static/media/MP0060.65e84328.jpg";